export function isQuestionFiveSequenceComplete({
  isRow5Complete,
  shouldShowKeywordRow,
  isKeywordRowComplete,
}) {
  if (!isRow5Complete) {
    return false;
  }

  if (!shouldShowKeywordRow) {
    return true;
  }

  return Boolean(isKeywordRowComplete);
}